import { createContext as e } from "../../utils/react/context.js";
const [n, o] = e({
  strict: !1,
  name: "MenuContext"
});
export {
  n as MenuProvider,
  o as useMenuContext
};
//# sourceMappingURL=useMenuContext.js.map
